






















import { ApiClient } from "@/api/client";
import { Component, PropSync } from "vue-property-decorator";
import { ToastProgrammatic as Toast } from "buefy";
import { UserAccount } from "@/interfaces/user";
import { mapState } from "vuex";
import Vue from "vue";
import store from "@/store";

@Component({
  computed: {
    ...mapState(["showChargeModal", "user"])
  }
})
export default class PurchaseButton extends Vue {
  @PropSync("content") syncedContent!: any;

  // Mapped from vuex
  showChargeModal!: boolean;
  user!: UserAccount;

  // Other variables
  api: ApiClient = new ApiClient();

  get canPurchase(): boolean {
    return this.user.balance >= this.syncedContent.price;
  }

  loading = false;
  success = false;

  get showModal(): boolean {
    return this.showChargeModal;
  }

  set showModal(newValue: boolean) {
    this.$store.commit("basic", {
      key: "showChargeModal",
      value: newValue
    });
  }

  async purchaseFromCoins() {
    this.loading = true;

    const response = await this.api.purchaseContentWithCoins(
      this.syncedContent.content_id
    );

    this.$store.commit("setUser", response.account);
    this.success = !!response.success;

    if (!this.success) {
      Toast.open({
        type: "is-danger",
        message: `Kauf konnte nicht durchgeführt werden: ${response.message}.`,
        duration: 3000,
        queue: false
      });
    } else {
      this.syncedContent.purchased_by_user = response.content.purchased_by_user;
      this.syncedContent.signed_cloudflare_video_id =
        response.content.signed_cloudflare_video_id;

      store.commit("setContent", response.content);

      Toast.open({
        type: "is-success",
        message: "Der Kauf war erfolgreich.",
        duration: 3000,
        queue: false
      });
    }

    this.loading = false;
  }
}
